<template>
  <div class="flex justify-between animate-pulse items-center w-full">
    <div>
      <div class="h-3 rounded bg-shimmer w-12 dark:bg-gray-850"></div>
      <div class="h-6 mt-1 rounded bg-shimmer w-24 dark:bg-gray-850"></div>
    </div>
    <div class="h-10 rounded bg-shimmer w-36 ms-2 dark:bg-gray-850"></div>
  </div>
</template>
